import { render, staticRenderFns } from "./Distances.vue?vue&type=template&id=99d2ae14&scoped=true&"
import script from "./Distances.vue?vue&type=script&lang=js&"
export * from "./Distances.vue?vue&type=script&lang=js&"
import style0 from "./Distances.vue?vue&type=style&index=0&id=99d2ae14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "99d2ae14",
  null
  
)

export default component.exports